import { getFetchOptions } from "../utils";
export function getCityFiasFromSuggestion(suggestion) {
    return suggestion.data.settlement_fias_id ?? suggestion.data.city_fias_id;
}
export function isInsideBeltway(suggestion) {
    return ['IN_MKAD', 'IN_KAD'].includes(suggestion?.data?.beltway_hit);
}
export function useDeliveryApi() {
    function getDeliveryInfoFromSuggestion(suggestion, addExtraDay) {
        return getDeliveryInfo(suggestion.data.region, getCityFiasFromSuggestion(suggestion), suggestion.data.postal_code, addExtraDay, isInsideBeltway(suggestion));
    }
    function getAddressInfo(id) {
        return fetch('/api/address_info', getFetchOptions({ id }, true)).then(response => response.json());
    }
    function getAddressesInfo() {
        return fetch('/api/addresses_info', getFetchOptions(null, true)).then(response => response.json());
    }
    function getDeliveryInfo(region, fias, zip, addExtraDay, insideBeltway = false) {
        return fetch('/api/delivery_calculator', getFetchOptions({ addExtraDay, region, fias, zip, insideBeltway: !!insideBeltway }, true))
            .then(response => response.json());
    }
    function getCDEKPoints(suggestion) {
        return fetch('/api/cdek/points', getFetchOptions({ fias: suggestion.region_fias_id }))
            .then(response => response.json());
    }
    function getCDEKPointInfo(id) {
        return fetch('/api/cdek/point_info', getFetchOptions({ id }))
            .then(response => response.json());
    }
    return {
        getAddressInfo,
        getAddressesInfo,
        getDeliveryInfo,
        getDeliveryInfoFromSuggestion,
        getCDEKPoints,
        getCDEKPointInfo,
    };
}
